import { createContext, useContext } from "react";

/** What a report starts with: the reference of the error it is about, if any. */
export interface IssueReportPrefill {
  readonly reference?: string;
}

/** Opens "Report a problem" (F13). */
export type OpenIssueReport = (prefill?: IssueReportPrefill) => void;

export const IssueReportContext = createContext<OpenIssueReport | null>(null);

/** `null` outside the working app (sign-in, setup), where there is no one to report as. */
export function useIssueReport(): OpenIssueReport | null {
  return useContext(IssueReportContext);
}
